/* Butterfly gift-wrap add-on: intercept product Add to Cart click and add the ₹50 service line */
(function () {
  const GIFT_VARIANT_ID = 67804194996437;
  const CHECKBOX_ID = 'butterfly-gift-wrap-choice';
  const BUSY = 'butterflyGiftWrapBusy';

  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function getProductForm(node) {
    return node && node.closest && node.closest('form[action*="/cart/add"], product-form form, form[data-type="add-to-cart-form"]');
  }
  function mountGiftWrap() {
    document.querySelectorAll('form[action*="/cart/add"], product-form form, form[data-type="add-to-cart-form"]').forEach(function (form) {
      if (form.querySelector('#' + CHECKBOX_ID)) return;
      const submit = form.querySelector('[type="submit"][name="add"], .product-form__submit, button[type="submit"]');
      if (!submit) return;
      const option = document.createElement('label');
      option.className = 'butterfly-gift-wrap-choice';
      option.htmlFor = CHECKBOX_ID;
      option.innerHTML = '<input type="checkbox" id="' + CHECKBOX_ID + '" name="butterfly_gift_wrap"><span class="butterfly-gift-wrap-choice__check" aria-hidden="true">✓</span><span class="butterfly-gift-wrap-choice__text"><strong>Is this a gift?</strong> 🎁 Wrap it for just <strong>₹50</strong><small>Tick this option to add gift wrapping to your order.</small></span>';
      const anchor = form.querySelector('.product-form__buttons, .buy-buttons, .product-form-buttons') || submit.parentElement;
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(option, anchor);
      else form.insertBefore(option, submit);
    });
  }

  async function addWithGift(form, button) {
    if (form.dataset[BUSY] === 'true') return;
    const checkbox = form.querySelector('#' + CHECKBOX_ID);
    if (!checkbox || !checkbox.checked) return;
    const variantInput = form.querySelector('[name="id"]');
    const variantId = variantInput && variantInput.value;
    if (!variantId) {
      alert('Please select a product option before adding to cart.');
      return;
    }
    form.dataset[BUSY] = 'true';
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    try {
      const quantityInput = form.querySelector('[name="quantity"]');
      const quantity = Math.max(1, parseInt(quantityInput && quantityInput.value || '1', 10) || 1);
      const response = await fetch(getRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [
          { id: Number(variantId), quantity: quantity, properties: { 'Gift wrapping': 'Yes (+₹50)' } },
          { id: GIFT_VARIANT_ID, quantity: 1 }
        ] })
      });
      const result = await response.json().catch(function () { return {}; });
      if (!response.ok) throw new Error(result.description || result.message || 'Gift wrapping could not be added. Please try again.');
      window.location.assign(getRoot() + 'cart');
    } catch (error) {
      alert(error.message || 'Unable to add gift wrapping. Please try again.');
      form.dataset[BUSY] = 'false';
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
    }
  }

  /* Dawn-style themes may handle the button click before a submit event fires. */
  document.addEventListener('click', function (event) {
    const button = event.target && event.target.closest && event.target.closest('button[type="submit"], button[name="add"], .product-form__submit');
    if (!button) return;
    const form = getProductForm(button);
    if (!form) return;
    const checkbox = form.querySelector('#' + CHECKBOX_ID);
    if (!checkbox || !checkbox.checked) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    addWithGift(form, button);
  }, true);

  /* Fallback for keyboard submits or forms submitted without a click. */
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const checkbox = form.querySelector('#' + CHECKBOX_ID);
    if (!checkbox || !checkbox.checked) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    const button = form.querySelector('[type="submit"][name="add"], .product-form__submit, button[type="submit"]');
    addWithGift(form, button);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountGiftWrap);
  else mountGiftWrap();
  new MutationObserver(mountGiftWrap).observe(document.documentElement, { childList: true, subtree: true });
})();